import axios from "axios"

const liveApiUrl = process.env.REACT_APP_LIVE_API_URL

export const getSubjectListApi = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("Token"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${liveApiUrl}/api/teacher-subjectAccess/accessClassSubject`,
      payload,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error While Creating Feedback:", error)
    throw error
  }
}

export const submitRequestAccessApi = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("Token"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${liveApiUrl}/api/teacher-subjectAccess/requestSubjectAccess`,
      payload,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error While Creating Feedback:", error)
    throw error
  }
}
